module.exports = {
    methods: {
        editAddress(addressId) {
            Bus.$emit("show-address-modal", addressId);
        }
    }
};
